import { render, staticRenderFns } from "./AppBarProject.vue?vue&type=template&id=db065e30"
import script from "./AppBarProject.vue?vue&type=script&lang=js"
export * from "./AppBarProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports